import UUIDBase from '@/models/UUIDBase'
import { useI18nInstance, localizeFieldName } from '@/plugins/i18n'
import CustomerAttachment from "@/models/customer/CustomerAttachment";
import DeliveryAttachment from "@/models/delivery/DeliveryAttachment";

const { t } = useI18nInstance().global

export const deliveryI18nMessages = {
  en: {
    name: 'Delivery company name',
    contactName: 'Contact Name',
    contactDisplayName: 'Contact Full Name',
    email: 'Email',
    phone: 'Phone',

    streetAddress: 'Street Address',
    city: 'City',
    postalCode: 'Postal Code',
    country: 'Country'
  },
  ar: {
    name: 'اسم شركة التوصيل',
    contactName: 'اسم جهة الاتصال',
    contactDisplayName: 'جهة الاتصال',
    email: 'البريد الالكتروني',
    phone: 'رقم الهاتف',

    streetAddress: 'عنوان الشركة',
    city: 'المدينة',
    postalCode: 'الرمز البريدي',
    country: 'الدولة'
  }
}

export default class Delivery extends UUIDBase {
  static from(json: Record<string, unknown> | Delivery) {
    return Object.assign(new Delivery(), json)
  }
  static ENDPOINT = '/company/delivery'

  name = ''

  contactName = ''
  email = ''
  phone = ''

  streetAddress = ''
  city = ''
  postalCode = ''
  country = ''
  deliveryAttachments: Array<DeliveryAttachment> = [];

  get contactDisplayName() {
    return `${this.contactName}`
  }

  validateName() {
    if (this.name.length === 0) {
      return t('validation.required', {
        field: localizeFieldName('name', deliveryI18nMessages)
      })
    } else if (this.name.length > 255) {
      return t('validation.maxLength', {
        field: localizeFieldName('name', deliveryI18nMessages)
      })
    }
  }
}
